<script setup lang="ts">
import { useAsyncData, useWTFApi } from '#imports';
import {
    useTransferHistoryColumns
} from '~/components/widgets/info-token/Activities/useTransferHistoryColumns';

interface Props {
    nftData?: AppWTFNft;
}
const {
    QueryWTFApiKey,
    nft
} = useWTFApi();
const { nftData } = defineProps<Props>();

const currentPage = ref(1);
const pageSize = ref(4);

const {
    data: transferHistory,
    status: transferHistoryStatus
} = useAsyncData(
    `${QueryWTFApiKey.HISTORY_TRANSFER}`,
    async () => {
        if (nftData) {
            const response = await nft.getNftTransferHistory({
                address: nftData.address,
                identifier: nftData.identifier,
                network: nftData.network,
                size: 10
            });
            return response.data;
        }
        return [];
    },
    {
        default: () => []
    }
);

// const transferHistoryArray = computed(() => {
//     return transferHistory.value ?? [];
// });
//
// const currentPage = ref(1);
// const pageSize = ref(4);
// const totalItems = computed(() => transferHistoryArray.value.length);
//
// function handlePageChange(newPage: number) {
//     currentPage.value = newPage;
// }

const columns = useTransferHistoryColumns();

</script>

<template>
  <Table :columns="columns"
         class="grow table"
         :is-loading="transferHistoryStatus === 'pending'"
         :data="transferHistory"
         :skeleton="{ rows: 4, height: 18 }">
    <template #no-data>
      <div class="display-flex flex-column align-items-center justify-center gap-12 pad-center">
        <div class="empty-circle display-flex align-items-center justify-center">
          <IconMain icon="air"
                    :size="28"
          />
        </div>
        <div class="display-flex flex-column align-items-center justify-center text-color-primary">
          <p class="compact-500-accent">
            No activities
          </p>
          <p class="text-400-default color-text-grey">
            No activities found.
          </p>
        </div>
      </div>
    </template>
  </Table>
<!--  <LazyPagination :page="currentPage"-->
<!--                        :size="pageSize"-->
<!--                        :total="totalItems"-->
<!--                        :visible-items="4"-->
<!--                        @on-page="handlePageChange"-->
<!--  />-->
</template>

<style lang="scss">
.arrow-block {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: var(--control-300-radius, 2px);
  background: rgb(233 234 236 / 10%);

  svg {
    color: #92FE75;
  }
}

.grow.table {
    overflow: auto;
}

.table-cell-left {
  text-align: end;
}

.table-header-left{
  padding-right: 12px;
}

</style>
